// import { Link } from "react-router-dom";
// import PageBanner from "../PageBanner";
// import SectionHeader from "../SectionHeader";
// import React from "react";
// import {
//   FaBarcode,
//   FaMicrochip,
//   FaChartLine,
//   FaTv,
//   FaRecycle,
//   FaMobileAlt,
// } from "react-icons/fa";
// import SocialMediaSidebar from "../SocialMediaSidebar";
// import ScrollToTopButton from "../ScrollToTopButton";

// const StoryofParking = () => {
//   return (
//     <>
//       <div>
//         <SocialMediaSidebar />
//       </div>
//       <PageBanner
//         title="The Story of Smart Pole"
//         breadcrumb={[
//           { label: "Home", href: "/" },
//           { label: "About Us" },
//           { label: "Story" },
//         ]}
//       />

//       <div className="max-w-6xl mx-auto p-4">
//         <SectionHeader
//           title="Story of Smart Pole @ AJEEVI"
//           shareUrl="https://swmecom.ajeevi.in/story-of-waste"
//         />
//       </div>
//       <div>
//         <ScrollToTopButton />
//       </div>

//       <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 text-[#1a1a1a] font-sans bg-white text-justify">
//         {/* Header Section */}
//         <h2 className="text-[#00D084] font-semibold text-2xl mb-2">
//           The Future of Smart Pole
//         </h2>
//         <h1 className="text-3xl md:text-2xl font-bold mb-6">
//           Enabling Smarter Cities: ICT's Role in Modern Infrastructure
//         </h1>

//         <p className="text-black text-lg mb-8">
//           Rapid urbanization has intensified parking challenges, with 30% of
//           urban traffic caused by drivers searching for parking spots.
//           Traditional parking systems lack real-time visibility, leading to
//           congestion, revenue leakage, and poor user experiences. ParkAJV's
//           IoT-powered Smart Parking Management System transforms this landscape
//           using{" "}
//           <strong>
//             AI, license plate recognition (LPR), and dynamic pricing
//           </strong>
//           . Our system deploys a network of sensors and cameras to monitor
//           parking occupancy in real-time, enabling automated check-ins/outs and
//           optimized space utilization. Municipalities gain data-driven insights
//           to implement demand-based pricing, while drivers enjoy reduced search
//           times and contactless payments. By integrating with city traffic
//           systems, we're creating seamless urban mobility ecosystems.
//         </p>

//         {/* RFID Section */}
//         <div className="grid md:grid-cols-2 gap-8 items-center bg-white mb-8">
//           {/* Card */}
//           <div className="shadow-2xl rounded bg-white px-6 py-10 text-center">
//             <div className="flex justify-center mb-4 text-green-500 text-6xl">
//               <FaBarcode />
//             </div>
//             <h3 className="text-xl font-bold mb-2">
//               Automated Vehicle Identification
//             </h3>
//             <p className="text-black text-lg">
//               License plate recognition (LPR) cameras and RFID tags enable
//               touchless entry/exit with 99.7% accuracy.
//             </p>
//           </div>

//           {/* Text */}
//           <div className="text-black text-lg leading-relaxed">
//             <p>
//               Every parking facility is equipped with{" "}
//               <span className="font-bold">AI-powered LPR cameras</span> and{" "}
//               <span className="font-bold">IoT sensors</span> that automatically
//               detect vehicle arrivals/departures. These systems capture license
//               plate data, timestamps, and space occupancy—creating a digital
//               twin of your parking assets for real-time monitoring.
//             </p>
//           </div>
//         </div>

//         <div className="grid md:grid-cols-2 gap-8 items-center bg-white mb-8">
//           {/* Text */}
//           <div className="text-black text-lg leading-relaxed">
//             <p>
//               Ultrasonic sensors and overhead cameras continuously monitor space
//               availability across{" "}
//               <strong>
//                 multi-level car parks (MLCP), on-street zones, and off-street
//                 lots
//               </strong>
//               . This real-time data feeds into our routing algorithms to guide
//               drivers to open spots via mobile apps and dynamic signage.
//             </p>
//           </div>

//           {/* Card */}
//           <div className="shadow-2xl rounded bg-white px-6 py-10 text-center">
//             <div className="flex justify-center mb-4 text-green-500 text-6xl">
//               <FaMicrochip />
//             </div>
//             <h3 className="text-xl font-bold mb-2">Smart Space Detection</h3>
//             <p className="text-black text-lg">
//               Overhead cameras and in-ground sensors track occupancy with 98%
//               accuracy, updating every 15 seconds.
//             </p>
//           </div>
//         </div>

//         <div className="grid md:grid-cols-2 gap-8 items-center bg-white mb-8">
//           {/* Card */}
//           <div className="shadow-2xl rounded bg-white px-6 py-10 text-center">
//             <div className="flex justify-center mb-4 text-green-500 text-6xl">
//               <FaChartLine />
//             </div>
//             <h3 className="text-xl font-bold mb-2">Demand-Based Pricing</h3>
//             <p className="text-black text-lg">
//               AI analyzes historical patterns and real-time demand to adjust
//               pricing dynamically—reducing congestion during peak hours.
//             </p>
//           </div>

//           {/* Text */}
//           <div className="text-black text-lg leading-relaxed">
//             <p>
//               Our machine learning models process parking data to predict demand
//               surges (events, rush hours) and automatically adjust pricing.
//               Municipalities see <strong>27% higher revenue</strong> while
//               maintaining 90%+ occupancy rates through optimized space
//               utilization.
//             </p>
//           </div>
//         </div>

//         <div className="grid md:grid-cols-2 gap-8 items-center bg-white mb-8">
//           {/* Text */}
//           <div className="text-black text-lg leading-relaxed">
//             <p>
//               Operators monitor entire parking networks through centralized
//               dashboards showing real-time occupancy heatmaps, revenue
//               analytics, and maintenance alerts. Automated reports simplify
//               auditing and policy planning.
//             </p>
//           </div>
//           {/* Card */}
//           <div className="shadow-2xl rounded bg-white px-6 py-10 text-center">
//             <div className="flex justify-center mb-4 text-green-500 text-6xl">
//               <FaTv />
//             </div>
//             <h3 className="text-xl font-bold mb-2">Command Center</h3>
//             <p className="text-black text-lg">
//               Live dashboards display occupancy trends, violation alerts, and
//               financial performance across all facilities.
//             </p>
//           </div>
//         </div>

//         <div className="grid md:grid-cols-2 gap-8 items-center bg-white mb-8">
//           {/* Card */}
//           <div className="shadow-2xl rounded bg-white px-6 py-10 text-center">
//             <div className="flex justify-center mb-4 text-green-500 text-6xl">
//               <FaMobileAlt />
//             </div>
//             <h3 className="text-xl font-bold mb-2">Driver Experience</h3>
//             <p className="text-black text-lg">
//               Mobile apps enable spot reservations, digital payments, and
//               navigation to available spaces—reducing search time by 70%.
//             </p>
//           </div>
//           {/* Text */}
//           <div className="text-black text-lg leading-relaxed">
//             <p>
//               Drivers access real-time availability via the ParkAJV app, with
//               turn-by-turn guidance to their reserved spot.{" "}
//               <strong>Contactless payments</strong> and e-receipts eliminate
//               cash handling, while integration with navigation apps (Google
//               Maps) provides seamless routing.
//             </p>
//           </div>
//         </div>

//         <div className="py-10 px-4 text-center">
//           <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-2">
//             This isn't just parking—it's AI-driven urban mobility optimization.
//           </h2>
//           <p className="text-gray-500 text-sm md:text-base">
//             Reducing congestion starts with smarter parking systems today.
//           </p>
//         </div>
//       </div>
//     </>
//   );
// };

// export default StoryofParking;


import { Link } from "react-router-dom";
import PageBanner from "../PageBanner";
import SectionHeaderNoPDF from "../SectionHeaderNoPDF";
import React from "react";
import {
  FaBroadcastTower,
  FaCamera,
  FaPhoneAlt,
  FaWifi,
  FaChartLine,
  FaCloud,
  FaThermometerHalf,
  FaWater,
} from "react-icons/fa";
import SocialMediaSidebar from "../SocialMediaSidebar";
import ScrollToTopButton from "../ScrollToTopButton";

const StoryofICT = () => {
  return (
    <>
      <div>
        <SocialMediaSidebar />
      </div>
      <PageBanner
        title="The Story of GyanYantram"
        breadcrumb={[
          { label: "Home", href: "/" },
          { label: "About Us" },
          { label: "Story" },
        ]}
      />

      <div className="max-w-6xl mx-auto p-4">
        <SectionHeaderNoPDF
          title="Story of GynaYantram @ GyanYantram"
          shareUrl="https://gyanyantram.ajeevi.in/story-of-ict"
        />
      </div>
      <div>
        <ScrollToTopButton />
      </div>

      <div className="w-full px-4 sm:px-6 md:px-10 lg:px-28 py-10 text-[#1a1a1a] font-sans bg-white text-justify">
        <h2 className="text-[#00D084] font-semibold text-2xl mb-2">
          The Story of Information Communication Technology
        </h2>
        <h1 className="text-3xl md:text-2xl font-bold mb-6">
          Enabling Smarter Cities: ICT's Role in Modern Infrastructure
        </h1>

        <p className="text-black text-lg mb-8">
          In the face of rapid urbanization and rising expectations, Information Communication Technology (ICT) is becoming the backbone of modern infrastructure. GyanYantram leverages ICT to create smarter, more connected, and more responsive cities. Our ICT-enabled ecosystem integrates real-time technologies like public announcement systems, surveillance, emergency communication, WiFi, and environmental sensing—all centrally managed through an intelligent platform to support efficient governance, enhance public safety, and promote digital inclusion.
        </p>

        {/* Public Announcement System */}
        <div className="grid md:grid-cols-2 gap-8 items-center bg-white mb-8">
          <div className="shadow-2xl rounded bg-white px-6 py-10 text-center">
            <div className="flex justify-center mb-4 text-green-500 text-6xl">
              <FaBroadcastTower />
            </div>
            <h3 className="text-xl font-bold mb-2">Public Announcement System</h3>
            <p className="text-black text-lg">
              Broadcasts real-time alerts and messages for public safety and awareness.
            </p>
          </div>
          <div className="text-black text-lg leading-relaxed">
            <p>
              This system allows authorities to instantly deliver safety instructions, event notifications, or emergency updates. It ensures timely communication and community engagement across all urban areas.
            </p>
          </div>
        </div>

        {/* Surveillance Cameras */}
        <div className="grid md:grid-cols-2 gap-8 items-center bg-white mb-8">
          <div className="text-black text-lg leading-relaxed">
            <p>
              High-definition surveillance integrated into city spaces enhances monitoring and security. These systems help deter crime, regulate traffic, and support emergency response teams through visual intelligence.
            </p>
          </div>
          <div className="shadow-2xl rounded bg-white px-6 py-10 text-center">
            <div className="flex justify-center mb-4 text-green-500 text-6xl">
              <FaCamera />
            </div>
            <h3 className="text-xl font-bold mb-2">Surveillance Cameras</h3>
            <p className="text-black text-lg">
              Continuous monitoring to improve safety, control traffic, and aid law enforcement.
            </p>
          </div>
        </div>

        {/* Emergency Call Unit */}
        <div className="grid md:grid-cols-2 gap-8 items-center bg-white mb-8">
          <div className="shadow-2xl rounded bg-white px-6 py-10 text-center">
            <div className="flex justify-center mb-4 text-green-500 text-6xl">
              <FaPhoneAlt />
            </div>
            <h3 className="text-xl font-bold mb-2">Emergency Call Unit</h3>
            <p className="text-black text-lg">
              Enables citizens to reach emergency services instantly via integrated buttons.
            </p>
          </div>
          <div className="text-black text-lg leading-relaxed">
            <p>
              In case of accidents or danger, these units provide a direct communication line to emergency responders, drastically reducing response times and enhancing safety in public areas.
            </p>
          </div>
        </div>

        {/* WiFi Connectivity */}
        <div className="grid md:grid-cols-2 gap-8 items-center bg-white mb-8">
          <div className="text-black text-lg leading-relaxed">
            <p>
              GyanYantram supports digital inclusion by offering public internet access through city-wide WiFi. This fosters connectivity, supports e-governance services, and strengthens access to education and innovation.
            </p>
          </div>
          <div className="shadow-2xl rounded bg-white px-6 py-10 text-center">
            <div className="flex justify-center mb-4 text-green-500 text-6xl">
              <FaWifi />
            </div>
            <h3 className="text-xl font-bold mb-2">WiFi Connectivity</h3>
            <p className="text-black text-lg">
              Promotes seamless access to the internet in public spaces for all citizens.
            </p>
          </div>
        </div>

        {/* IoT Dashboard */}
        <div className="grid md:grid-cols-2 gap-8 items-center bg-white mb-8">
          <div className="shadow-2xl rounded bg-white px-6 py-10 text-center">
            <div className="flex justify-center mb-4 text-green-500 text-6xl">
              <FaChartLine />
            </div>
            <h3 className="text-xl font-bold mb-2">IoT Dashboard</h3>
            <p className="text-black text-lg">
              Centralized system to manage real-time data for smarter urban governance.
            </p>
          </div>
          <div className="text-black text-lg leading-relaxed">
            <p>
              The IoT dashboard collects, visualizes, and analyzes urban data in real-time. It aids decision-makers in planning infrastructure, managing resources, and responding quickly to changing city dynamics.
            </p>
          </div>
        </div>

        {/* Flood Sensor */}
        <div className="grid md:grid-cols-2 gap-8 items-center bg-white mb-8">
          <div className="text-black text-lg leading-relaxed">
            <p>
              Flood sensors detect rising water levels and alert authorities to prevent accidents, traffic disruptions, or infrastructure damage—especially in flood-prone urban zones.
            </p>
          </div>
          <div className="shadow-2xl rounded bg-white px-6 py-10 text-center">
            <div className="flex justify-center mb-4 text-green-500 text-6xl">
              <FaWater />
            </div>
            <h3 className="text-xl font-bold mb-2">Flood Sensor</h3>
            <p className="text-black text-lg">
              Detects flood risk in real time to prevent urban water logging and disasters.
            </p>
          </div>
        </div>

        {/* Environmental Sensor */}
        <div className="grid md:grid-cols-2 gap-8 items-center bg-white mb-8">
          <div className="shadow-2xl rounded bg-white px-6 py-10 text-center">
            <div className="flex justify-center mb-4 text-green-500 text-6xl">
              <FaCloud />
            </div>
            <h3 className="text-xl font-bold mb-2">Environmental Sensor</h3>
            <p className="text-black text-lg">
              Tracks AQI, pollutants, and toxic gases for environmental health monitoring.
            </p>
          </div>
          <div className="text-black text-lg leading-relaxed">
            <p>
              These sensors monitor air quality and pollution in real time, enabling sustainable urban practices and regulatory compliance. Alerts are sent for immediate actions in pollution-affected zones.
            </p>
          </div>
        </div>

        {/* Temperature Sensor */}
        <div className="grid md:grid-cols-2 gap-8 items-center bg-white mb-8">
          <div className="text-black text-lg leading-relaxed">
            <p>
              With real-time temperature tracking, cities can forecast weather trends, identify heatwave zones, and optimize energy distribution and urban comfort strategies.
            </p>
          </div>
          <div className="shadow-2xl rounded bg-white px-6 py-10 text-center">
            <div className="flex justify-center mb-4 text-green-500 text-6xl">
              <FaThermometerHalf />
            </div>
            <h3 className="text-xl font-bold mb-2">Temperature Sensor</h3>
            <p className="text-black text-lg">
              Monitors environmental temperatures for weather analysis and smart planning.
            </p>
          </div>
        </div>

        <div className="py-10 px-4 text-center">
          <h2 className="text-2xl md:text-3xl font-semibold text-gray-900 mb-2">
            This is not just infrastructure. This is intelligent, connected, and sustainable city management.
          </h2>
          <p className="text-gray-500 text-sm md:text-base">
            A smarter tomorrow begins with integrated ICT systems today.
          </p>
        </div>
      </div>
    </>
  );
};

export default StoryofICT;
